import { AxiosPromise } from 'axios';
import api from './api';

export interface ValidateData {
  registrationNumber: string;
  birthDate: string;
  admissionDate: string;
}

interface ValidateResponse {
  status: string;
  access_token: string;
}

export interface RegisterUserData {
  accessToken: string;
  registrationNumber: string;
  acceptTerms: boolean;
  companyId: string;
  documentNumber: string;
  email: string;
  password: string;
  fullName: string;
}

interface RegisterUserResponse {
  accessToken: string;
  registrationNumber: string;
  acceptTerms: boolean;
  companyId: string;
  documentNumber: string;
  email: string;
  password: string;
}

export const validateUser = (data: ValidateData): AxiosPromise<ValidateResponse> => api.post('/customers/lasa/login', data);

export const registerUser = (data: RegisterUserData): AxiosPromise<RegisterUserResponse> => api.post('/customers/import-customer-from-lasa', data);
